<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />

    <ValidationObserver v-slot="{ handleSubmit }">
      <div class="page-tabs-content">
        <div>
          <table class="table">
            <thead>
              <tr>
                <th colspan="4">
                  <h3 class="text-center"><strong>安裝頁面</strong></h3>
              </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style="width: 600px">
                  <span class="mark">*</span>
                  <span> 管理者帳號：</span>
                </td>
                <td>
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input
                      type="text"
                      class="form-control"
                      maxlength="256"
                      v-model="setting.ManagerUserName"
                    />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </td>
              </tr>
              <tr>
                <td style="width: 600px">
                  <span class="mark">*</span>
                  <span> 管理者密碼：</span>
                </td>
                <td>
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input
                      type="password"
                      class="form-control"
                      maxlength="256"
                      v-model="setting.ManagerPassword"
                    />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="mark">*</span>
                  <span> 管理者姓名：</span>
                </td>
                <td>
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input
                      type="text"
                      class="form-control"
                      maxlength="256"
                      v-model="setting.ManagerName"
                    />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="mark">*</span>
                  <span> 管理者 Email：</span>
                </td>
                <td>
                  <ValidationProvider
                    rules="required|email"
                    v-slot="{ errors }"
                  >
                    <input
                      type="text"
                      class="form-control"
                      maxlength="256"
                      v-model="setting.ManagerEmail"
                    />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="mark">*</span>
                  <span> 管理者連絡電話： </span>
                </td>
                <td>
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input
                      type="text"
                      class="form-control"
                      maxlength="256"
                      v-model="setting.ManagerPhoneNumber"
                    />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div>
          <table class="table">
            <tbody>
              <tr>
                <th id="company" style="width: 600px">
                  <span class="mark">*</span>
                  <span> 公司名稱： </span>
                </th>
                <td>
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input
                      type="text"
                      class="form-control"
                      maxlength="256"
                      v-model="setting.CompanyName"
                    />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </td>
              </tr>
              <tr>
                <td>
                  <span style="padding-left: 16px">公司LOGO(適用淺色背景)</span>
                </td>
                <td>
                  <el-upload
                    class="upload-demo"
                    action
                    accept="image/jpeg,image/png"
                    :auto-upload="false"
                    :show-file-list="false"
                    list-type="picture"
                    :on-change="uploadFile"
                    v-model="setting.CompanyLogoFileGroupGuid"
                  >
                    <el-button
                      size="small"
                      type="primary"
                      @click="clickUpload('dark')"
                    >
                      上傳圖片
                    </el-button>
                    <div slot="tip" class="el-upload__tip mark">
                      僅能上傳 jpg/png 檔案，且大小不超過10MB
                    </div>
                  </el-upload>
                </td>
              </tr>
              <tr>
                <td>
                  <span style="padding-left: 16px">公司LOGO(適用深色背景)</span>
                </td>
                <td>
                  <el-upload
                    class="upload-demo"
                    action
                    accept="image/jpeg,image/png"
                    :auto-upload="false"
                    :show-file-list="false"
                    list-type="picture"
                    :on-change="uploadFile"
                    v-model="setting.CompanyLogoLightFileGroupGuid"
                  >
                    <el-button
                      size="small"
                      type="primary"
                      @click="clickUpload('light')"
                    >
                      上傳圖片
                    </el-button>
                    <div slot="tip" class="el-upload__tip mark">
                      僅能上傳png格式，且大小不超過10MB
                    </div>
                  </el-upload>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div>
          <table class="table">
            <tbody>
              <tr>
                <th id="server" style="width: 600px">
                  <span class="mark">*</span>
                  <span> SMTP Server： </span>
                </th>
                <td>
                  <ValidationProvider
                    ref="SmtpServer"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <input
                      type="text"
                      class="form-control"
                      v-model="setting.SmtpServer"
                    />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </td>
              </tr>
              <tr>
                <td>
                  <span style="padding-left: 17px"> SMTP 帳號： </span>
                </td>
                <td>
                  <input
                    type="text"
                    class="form-control"
                    v-model="setting.SmtpAccount"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <span style="padding-left: 17px"> SMTP 密碼： </span>
                </td>
                <td>
                  <input
                    type="password"
                    class="form-control"
                    v-model="setting.SmtpPassword"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <span class="mark">*</span>
                  <span> Port： </span>
                </td>
                <td>
                  <ValidationProvider
                    ref="SmtpPort"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <input
                      type="text"
                      class="form-control"
                      v-model="setting.SmtpPort"
                    />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="mark">*</span>
                  <span> 啟用SSL： </span>
                </td>
                <td>
                  <el-switch
                    active-color="#13ce66"
                    inactive-color="#808080"
                    v-model="setting.SmtpIsSSL"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <span class="mark">*</span>
                  <span> 預設寄件者信箱： </span>
                </td>
                <td>
                  <ValidationProvider
                    ref="SmtpSenderMail"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <input
                      type="text"
                      class="form-control"
                      v-model="setting.SmtpSenderMail"
                    />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="mark">*</span>
                  <span> 寄件者： </span>
                </td>
                <td>
                  <ValidationProvider
                    ref="SmtpSenderName"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <input
                      type="text"
                      class="form-control"
                      v-model="setting.SmtpSenderName"
                    />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </td>
              </tr>
              <tr>
                <td>
                  <span style="padding-left: 17px"> 測試收件者： </span>
                </td>
                <td class="text-right" style="display: flex; flex-wrap: wrap">
                  <input
                    style="display: flex; flex-basis: 90%"
                    type="text"
                    class="form-control"
                    v-model="Receiver"
                  />
                  <div style="display: flex; flex: 0 0 10%; padding-left: 15px">
                    <button type="button" class="btn btn-info" @click="test">
                      測試
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div style="text-align: center">
        <button
          type="button"
          class="btn btn-primary"
          @click="handleSubmit(save)"
        >
          儲存
        </button>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "Setting",

  data() {
    return {
      setting: {
        SmtpIsSSL: true,
        CompanyLogoFileGroupGuid: "",
        CompanyLogoLightFileGroupGuid: "",
      },

      Receiver: null,

      imgCategory: "dark",
    };
  },

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  methods: {
    // 點擊上傳圖片按鈕
    clickUpload(category) {
      this.imgCategory = category;
    },

    // 上傳 檔案
    uploadFile(file) {
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isLt10M) {
        this.$notify({
          title: "失敗",
          message: "檔案大小不得超過10MB",
          type: "error",
          duration: 3500,
        });
        return false;
      }

      this.updateLoading(true);

      let fileGroupGuid;
      switch (this.imgCategory) {
        case "dark":
          fileGroupGuid = this.setting.CompanyLogoFileGroupGuid;
          break;
        case "light":
          fileGroupGuid = this.setting.CompanyLogoLightFileGroupGuid;
          break;
      }

      let fd = new FormData();
      fd.append("File", file.raw);
      fd.append("FileType", file.raw.type);
      fd.append("FileGroupGuid", fileGroupGuid);
      fd.append("CreateUser", null);

      this.$api.file.uploadFile(fd).then((response) => {
        if (response.status === 200) {
          this.updateLoading(false);

          switch (this.imgCategory) {
            case "dark":
              this.setting.CompanyLogoFileGroupGuid = response.data;
              break;
            case "light":
              this.setting.CompanyLogoLightFileGroupGuid = response.data;
              break;
          }

          this.$notify({
            title: "成功",
            message: "上傳成功",
            type: "success",
            duration: 2500
          });
        }
      });
    },

    // 測試 API
    test() {
      const vm = this;
      if (
        vm.setting.SmtpServer &&
        vm.setting.SmtpPort &&
        vm.setting.SmtpSenderMail &&
        vm.setting.SmtpSenderName &&
        vm.Receiver
      ) {
        const api = `${window.endpoints.api}/BasicInformation/config/SendTestMail`;
        const data = {
          SmtpServer: vm.setting.SmtpServer,
          SmtpAccount: vm.setting.SmtpAccount,
          SmtpPassword: vm.setting.SmtpPassword,
          SmtpPort: vm.setting.SmtpPort,
          SmtpIsSSL: vm.setting.SmtpIsSSL,
          SmtpSenderMail: vm.setting.SmtpSenderMail,
          SmtpSenderName: vm.setting.SmtpSenderName,
          Receiver: vm.Receiver,
        };

        vm.$store.dispatch("updateLoading", true);

        vm.$http
          .post(api, data)
          .then((response) => {
            if (response.status === 200) {
              vm.$store.dispatch("updateLoading", false);

              vm.$notify({
                title: "成功",
                message: "已發送測試信件",
                type: "success",
                duration: 2500,
              });
            }
          })
          .catch((error) => {
            vm.$store.dispatch("updateLoading", false);
            vm.$notify({
              title: "失敗",
              message: error.response.data,
              type: "error",
              duration: 3500,
            });
          });
      } else {
        vm.$refs.SmtpServer.validate();
        vm.$refs.SmtpPort.validate();
        vm.$refs.SmtpSenderMail.validate();
        vm.$refs.SmtpSenderName.validate();
        vm.$notify({
          title: "失敗",
          message: "測試收件者為必填",
          type: "error",
          duration: 3500,
        });
      }
    },

    // 儲存 API
    async save() {
      const vm = this;
      const api = `${window.endpoints.api}/BasicInformation/config/FirstRunning`;

      const data = { ...vm.setting };
      if (data.CompanyLogoFileGroupGuid === "") {
        data.CompanyLogoFileGroupGuid = null;
      }
      if (data.CompanyLogoLightFileGroupGuid === "") {
        data.CompanyLogoLightFileGroupGuid = null;
      }
      vm.$store.dispatch("updateLoading", true);

      await vm.$http
        .post(api, data)
        .then((response) => {
          if (response.status === 200) {
            vm.$store.dispatch("updateLoading", false);

            vm.$notify({
              title: "成功",
              message: "儲存成功",
              type: "success",
              duration: 2500,
            });

            vm.$router.push({ path: "/manager/index" });
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "儲存失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // loading
    ...mapActions(["updateLoading"]),
  },
};
</script>
